import { MenuItem } from './MenuItem'
import { MenuInnerWithSub } from './MenuInnerWithSub'
import { useAuth } from '../../../../../app/modules/auth'
import { featureFlags } from '../../../../../config/countryConfig'
import { useIntl } from 'react-intl'

export function MenuInner() {
  const { checkPermission } = useAuth()
  const intl = useIntl()

  return (
    <>
      {checkPermission('Dashboard', 'can_read') && <MenuItem title={intl.formatMessage({ id: 'MENU.DASHBOARD', defaultMessage: 'Dashboard' })} to='/dashboard' />}
      {checkPermission('URL Verification', 'can_read') && <MenuItem title={intl.formatMessage({ id: 'PAGE.URL_VERIFICATION', defaultMessage: 'URL Verification' })} to='/urlverification' />}
      {featureFlags.urlMappedTemplates && checkPermission('Mapped URLs', 'can_read') && (
        <MenuItem title={intl.formatMessage({ id: 'PAGE.MANAGE_TEMPLATE', defaultMessage: 'URL Mapped Templates' })} to='/managetemplate' />
      )}
      {checkPermission('SMS Report', 'can_read') && <MenuItem title={intl.formatMessage({ id: 'NAV.MESSAGE_DATA', defaultMessage: 'Message Data' })} to='/smsreport' />}
      {checkPermission('Vendor List', 'can_read') && <MenuItem title={intl.formatMessage({ id: 'PAGE.IP_LIST', defaultMessage: 'PE-TM Details' })} to='/iplist' />}
      {/* {
        auth?.user?.group_obj?.available_permissions.filter(ele => ele.permission.name == "Global Blacklist").length > 0 &&
        <MenuInnerWithSub title='Global Blacklist' to='/blacklist' menuPlacement='bottom-start' menuTrigger='click'>
          <MenuItem to='/blacklisturl' title='URL Blacklist' icon='fasten' />
          <MenuItem to='/blacklistip' title='IP Blacklist' icon='focus' />
        </MenuInnerWithSub>
      } */}
      {checkPermission('Account Statistics', 'can_read') && <MenuItem title={intl.formatMessage({ id: 'PAGE.ACCOUNT_STATISTICS', defaultMessage: 'Account Statistics' })} to='/operatordata' />}
      {featureFlags.kycVerification && (
        <MenuItem title={intl.formatMessage({ id: 'PAGE.KYC_VERIFICATION', defaultMessage: 'KYB Verification' })} to='/kycverification' />
      )}
      {featureFlags.senderApproval && (
        <MenuItem title={intl.formatMessage({ id: 'PAGE.SENDER_APPROVAL', defaultMessage: 'Sender Approval' })} to='/senderapproval' />
      )}
      {(checkPermission('User Management', 'can_read') ||
        checkPermission('Roles Management', 'can_read')) && (
          <MenuInnerWithSub
            title={intl.formatMessage({ id: 'NAV.ACCOUNT_CONTROL', defaultMessage: 'Account Control' })}
            to='/account'
            menuPlacement='bottom-start'
            menuTrigger='click'
          >
            {checkPermission('User Management', 'can_read') && (
                <MenuItem to='/usermanagement' title={intl.formatMessage({ id: 'PAGE.USER_MANAGEMENT', defaultMessage: 'User Management' })} icon='profile-user' />
              )}
            {checkPermission('Roles Management', 'can_read') && (
                <MenuItem to='/rolesmanagement' title={intl.formatMessage({ id: 'PAGE.ROLES_MANAGEMENT', defaultMessage: 'Roles Management' })} icon='burger-menu-3' />
              )}
          </MenuInnerWithSub>
        )}
      {checkPermission('Support Center', 'can_read') && <MenuItem title={intl.formatMessage({ id: 'NAV.TICKETS', defaultMessage: 'Tickets' })} to='/support' />}
    </>
  )
}
